import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Button, Modal, Form, Input, message, Pagination } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { SidebarLayout } from '../components/SidebarLayout';
import axios from 'axios';

const api = `${process.env.REACT_APP_API_URL}/device_type`;

const DeviceTypeForm = ({ visible, onCancel, onSubmit, initialValues }) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if (visible) form.setFieldsValue(initialValues || {}); else form.resetFields();
  }, [visible, initialValues]);
  return (
    <Modal
      visible={visible}
      title={initialValues ? 'Editar Tipo' : 'Novo Tipo'}
      onCancel={onCancel}
      onOk={() => {
        form.validateFields().then(values => {
          form.resetFields();
          onSubmit(values);
        });
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="dsname"
          label="Nome do Tipo"
          rules={[
            { required: true, message: 'Nome do tipo é obrigatório' },
            { max: 100, message: 'Máximo de 100 caracteres' }
          ]}
        >
          <Input maxLength={100} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const DeviceType = () => {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingType, setEditingType] = useState(null);
  const [formVisible, setFormVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [messageApi, contextHolder] = message.useMessage();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;

  const fetchTypes = async () => {
    setLoading(true);
    try {
      const res = await axios.get(api);
      setTypes(res.data);
    } catch {
      messageApi.error('Erro ao buscar tipos');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  const handleCreate = async values => {
    try {
      await axios.post(api, values);
      messageApi.success('Tipo criado com sucesso');
      fetchTypes();
    } catch (error) {
      var apiMsg = 'Erro ao criar tipo';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    }
    setFormVisible(false);
  };

  const handleUpdate = async values => {
    try {
      await axios.put(`${api}/${editingType.id}`, values);
      messageApi.success('Tipo atualizado com sucesso');
      fetchTypes();
    } catch (error) {
      var apiMsg = 'Erro ao atualizar tipo';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    }
    setEditingType(null);
    setFormVisible(false);
  };

  const handleDelete = id => {
    Modal.confirm({
      title: 'Tem certeza que deseja remover este tipo?',
      content: 'Esta ação não poderá ser desfeita.',
      okText: 'Sim, remover',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: async () => {
        try {
          await axios.delete(`${api}/${id}`);
          messageApi.success('Tipo removido com sucesso');
          fetchTypes();
        } catch (error) {
          var apiMsg = 'Erro ao remover tipo';
          if (error.response?.status != 500) {
            apiMsg +=  ': ' + error.response?.data?.error || '!';
          }
          messageApi.error(apiMsg);
        }
      }
    });
  };

  const filteredTypes = types.filter(type =>
    type.dsname.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <SidebarLayout>
      {contextHolder}
      <div style={{ padding: 24 }}>
        <h1>Tipos de Dispositivos</h1>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingType(null);
              setFormVisible(true);
            }}
          >
            Novo Tipo
          </Button>
          <Input.Search
            placeholder="Buscar tipo de dispositivo"
            allowClear
            onSearch={value => setSearchText(value)}
            onChange={e => setSearchText(e.target.value)}
            style={{ width: 300 }}
          />
        </div>

        <Row gutter={[42, 32]}>
          {filteredTypes
            .slice((currentPage - 1) * pageSize, currentPage * pageSize)
            .map(type => (
              <Col xs={24} sm={12} md={8} lg={8} key={type.id}>
                <Card
                  actions={[
                    <EditOutlined key="edit" onClick={() => { setEditingType(type); setFormVisible(true); }} />,
                    <DeleteOutlined key="delete" style={{ color: 'red' }} onClick={() => handleDelete(type.id)} />
                  ]}
                  style={{ boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', padding: 0 }}
                >
                  
                  <p><b>Nome:</b> {type.dsname}</p>
                </Card>
              </Col>
            ))}
        </Row>

        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'end' }}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={filteredTypes.length}
            onChange={page => setCurrentPage(page)}
            showSizeChanger={false}
          />
        </div>

        <DeviceTypeForm
          visible={formVisible}
          onCancel={() => setFormVisible(false)}
          onSubmit={editingType ? handleUpdate : handleCreate}
          initialValues={editingType}
        />
      </div>
    </SidebarLayout>
  );
};
